function checkForAlternateHeader() {
  const altHeader = document.getElementById('showAlternateHeader');
  const header = document.querySelector('.shopify-section--header');

  
  if (altHeader) {
    header.classList.add('shopify-section--header-alternative');
  }
}

function stickyHeader() {
  let lastScrollTop = 0;
  const header = document.querySelector('.shopify-section--header');
   

  
  window.addEventListener('scroll', () => {
    const debounceStickyHeader = debounce(hasScrolled(header, lastScrollTop), 500);
  });
}

function hasScrolled(header, lastScrollTop) {
  const headerHeight = header.offsetTop;

  // If they scrolled down and are past the navbar, add class .nav-up.
  // This is necessary so you never see what is "behind" the navbar.
  header.classList.add('is--sticky');
  if (window.pageYOffset === 0) {
    // Scroll Up
    header.classList.remove('is--sticky');

  }

  lastScrollTop = headerHeight;
}

const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
};

// Page load functions
stickyHeader();
checkForAlternateHeader();
